import $ from 'jquery';
import { startExpand } from '~core/expand';

export default function initExpandListeners() {
  $('body').on('click', '#editor-menu-image-expand', startExpand);
}
